import { useEffect } from 'react'
import { type Blocker, useBlocker } from 'react-router'

/** Holds navigation away from the tab while any card has unsaved edits. */
export function useUnsavedEditsGuard(dirtyLabels: string[]): Blocker {
  const dirty = dirtyLabels.length > 0
  // A changed pathname is another tab or another customer; query-string changes stay put.
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => dirty && currentLocation.pathname !== nextLocation.pathname
  )

  useEffect(() => {
    if (!dirty) return
    function warn(event: BeforeUnloadEvent) {
      event.preventDefault()
      event.returnValue = ''
    }
    window.addEventListener('beforeunload', warn)
    return () => window.removeEventListener('beforeunload', warn)
  }, [dirty])

  return blocker
}
